import type { CSSProperties } from "react";

type Styles = Record<string, CSSProperties>;

export const authStyles: Styles = {
  signInButton: {
    height: "32px",
    padding: "0 16px",
    backgroundColor: "transparent",
    border: "1px solid var(--color-border)",
    borderRadius: "6px",
    color: "var(--color-text-secondary)",
    fontSize: "13px",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 150ms ease",
  },
  signUpButton: {
    height: "32px",
    padding: "0 16px",
    backgroundColor: "var(--color-accent)",
    border: "none",
    borderRadius: "6px",
    color: "#fff",
    fontSize: "13px",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 150ms ease",
  },

  skeleton: {
    width: 32,
    height: 32,
    borderRadius: "50%",
    backgroundColor: "var(--color-bg-elevated)",
    animation: "pulse 1.5s ease-in-out infinite",
  },

  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "120px",
    gap: "16px",
  },
  loadingSpinner: {
    width: 32,
    height: 32,
    border: "3px solid var(--color-bg-elevated)",
    borderTop: "3px solid var(--color-accent)",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
  },
  loadingText: {
    color: "var(--color-text-secondary)",
    fontSize: "14px",
  },

  promptOverlay: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: "80px",
    paddingBottom: "40px",
  },
  promptCard: {
    backgroundColor: "var(--color-bg-surface)",
    border: "1px solid var(--color-border)",
    borderRadius: "12px",
    padding: "48px 40px",
    maxWidth: "440px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 16px 48px rgba(0, 0, 0, 0.3)",
  },
  promptIcon: {
    marginBottom: "24px",
  },
  promptTitle: {
    color: "var(--color-text-primary)",
    fontSize: "22px",
    fontWeight: 600,
    margin: "0 0 12px 0",
    letterSpacing: "-0.01em",
  },
  promptSubtitle: {
    color: "var(--color-accent-text)",
    fontSize: "14px",
    fontWeight: 500,
    margin: "-4px 0 16px 0",
  },
  promptMessage: {
    color: "var(--color-text-secondary)",
    fontSize: "15px",
    lineHeight: 1.5,
    margin: "0 0 16px 0",
    display: "block",
  },
  promptFeatures: {
    textAlign: "left",
    margin: "0 auto 24px",
    maxWidth: "280px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  promptFeature: {
    color: "var(--color-text-secondary)",
    fontSize: "14px",
    lineHeight: 1.4,
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  promptButtons: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    marginBottom: "24px",
  },
  promptSignIn: {
    height: "36px",
    padding: "0 24px",
    backgroundColor: "var(--color-accent)",
    border: "none",
    borderRadius: "8px",
    color: "#fff",
    fontSize: "15px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 150ms ease",
  },
  promptSignUp: {
    height: "36px",
    padding: "0 24px",
    backgroundColor: "transparent",
    border: "1px solid var(--color-border)",
    borderRadius: "8px",
    color: "var(--color-text-secondary)",
    fontSize: "15px",
    fontWeight: 500,
    cursor: "pointer",
    transition: "all 150ms ease",
  },
  promptFooter: {
    color: "var(--color-text-tertiary)",
    fontSize: "13px",
    margin: 0,
  },
};

export const CLERK_ENABLED = !!process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
